import { render } from "./chujinews.vue?vue&type=template&id=52a15ccd&scoped=true"
import script from "./chujinews.vue?vue&type=script&lang=js"
export * from "./chujinews.vue?vue&type=script&lang=js"

import "./chujinews.vue?vue&type=style&index=0&id=52a15ccd&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a15ccd"]])

export default __exports__